// extracted by mini-css-extract-plugin
module.exports = {"wordWrap":"WordWrap_wordWrap__2-N25"};